module.exports = __webpack_public_path__ + "img/inco4.e4a7cc1f.png";